import { atom } from "recoil";

export const loadingState = atom({
  key: "loadingState",
  default: false,
});
export const loadingText = atom({
  key: "loadingText",
  default: "",
});
